import React from 'react';
import AButton from '../../../../../common/form-fields-mui/AButton';
import { ReactComponent as UploadIcon } from "../../../../../../../../assets/img/svg/upload.svg"
import styles from "./styles.module.scss";

const ManualConsentActions = ({
    setConsentUploadDialogOpen,
    createManualParentConsentForm,
    setAsyncLoader,
    enableUserActions
}) => {


    const downloadManualParentConsentForm = async () => {
        try {
            setAsyncLoader(true);
            const resp = await createManualParentConsentForm();
            if (resp?.code === 200) {
                const pdfBuffer = resp?.pdfFile?.data;
                const uint8Array = new Uint8Array(pdfBuffer);

                const blob = new Blob([uint8Array], { type: "application/pdf" });
                const blobUrl = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = "ParentConsent.pdf";

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setAsyncLoader(false);
        }
    }

    return (
        <div className='d-flex'>
            <AButton
                variant="outline"
                size="xs"
                outlineVariantColor="#CCCCCC"
                textColor="#0F0F0F"
                onClick={downloadManualParentConsentForm}
            >
                Download Form
            </AButton>

            {enableUserActions && <span className='ml-2'>
                <AButton
                    variant="outline"
                    size="xs"
                    onClick={() => setConsentUploadDialogOpen(true)}
                >
                    <>
                        <UploadIcon className={styles['upload-icon']} />
                        Upload consent manually
                    </>
                </AButton>
            </span>}
        </div>
    );
}

export default ManualConsentActions;